<mat-toolbar class="toolbar top">
  <span class="main-heading-text">{{ title }}</span>
  <img class="pointer" src="assets/project-icons/x.svg" alt="X" (click)="close.emit()" />
</mat-toolbar>

<div class="map-editor-container">
  <div class="controls" *transloco="let t">
    <h4>{{t('stepObjectives')}}</h4>
    @if (!markerReachEditEngines?.size && !markerFindEditEngines?.size && !discoveryEditEngines?.size) {
      <div class="regular-14 margin-left-12">
        *{{t('atLeastOneObjectiveHasToBePresent')}}
      </div>
    }


    @for (engineEntry of markerReachEditEngines; track engineEntry[0]) {
      @let engine = engineEntry[1];
      @if (!!engine.getData().coords) {
        <div class="chips-container">
          <app-active-chip
            [text]="engine.getData().name + ' (' + engine.getData().zoneAreaPretty + ')'"
            [selected]="engine.editing"
            [color]="!!engine.getData().coords || startZoneEditEngine.isValid() ? 'default' : 'red'"
            (click)="clickMarkerReachBtn(engine)"
            (close)="engine.clear(); removeObjective(engineEntry[0])"
          >
          </app-active-chip>
          <lib-coordinates-inputs [coords]="engine.getData().coords" (coordsChange)="engine.clickOnMap($event, true)"></lib-coordinates-inputs>
        </div>
      }
    }
    <div class="controls-row margin-bottom-12 margin-top-8">
      <button
        class="secondary-bar-btn add-buttons"
        (click)="addObjective(QuestStepObjectiveType.markerReach)"
        [ngClass]="{ active: editMode === 'reachMarker' }"
      >
        <svg class="smaller-img-size" viewBox="0 0 24 24" width="18" height="18">
          <use xlink:href="assets/project-icons/add.svg#a"></use>
        </svg>
        {{t('addPlace')}}
      </button>
      <app-tooltip [paragraphs]="[t('addPlaceTooltipP1'), t('addPlaceTooltipP2')]" [position]="'left'"></app-tooltip>
    </div>

    @if (config.questMode !== QuestMode.noMap) {
      @for (engineEntry of markerFindEditEngines; track engineEntry[0]) {
        @let engine = engineEntry[1];
        @if (!!engine.getData().coords) {
          <div class="controls-row margin-top-18">
            <!--        TODO to show dragged part of the range as blue, we need to create a custom wrapper component over input where that blue part will actually be another div-->
            <input type="range" min="50" max="1000" [formControl]="engine.radiusControl" class="general-range" />
            <span class="range-label">
            {{ metersToPretty(engine.radiusControl.value) }}
          </span>
          </div>
        }
        <div class="chips-container">
          @if (!!engine.getData().coords) {
            <app-active-chip
              [text]="engine.getData().name"
              [selected]="engine.editing"
              [color]="!!engine.getData().coords || engine.isValid() ? 'default' : 'red'"
              (click)="clickMarkerFindBtn(engine)"
              (close)="engine.clear(); stopCurrentEdit()"
            >
            </app-active-chip>
            <lib-coordinates-inputs [coords]="engine.getData().coords" (coordsChange)="engine.clickOnMap($event, true)"></lib-coordinates-inputs>
          }
        </div>
      }
      <div class="controls-row margin-bottom-12 margin-top-8">
        <button
          class="secondary-bar-btn add-buttons"
          (click)="addObjective(QuestStepObjectiveType.markerFind)"
          [ngClass]="{ active: editMode === 'findMarker' }"
        >
          <svg class="smaller-img-size" viewBox="0 0 24 24" width="18" height="18">
            <use xlink:href="assets/project-icons/add.svg#a"></use>
          </svg>
          {{t('addHiddenPlace')}}
        </button>
        <app-tooltip [paragraphs]="[t('addHiddenPlaceTooltipP1'), t('addHiddenPlaceTooltipP2'), t('addHiddenPlaceTooltipP3')]" [position]="'left'"></app-tooltip>
      </div>

      @for (engineEntry of discoveryEditEngines; track engineEntry[0]) {
        @let engine = engineEntry[1];
        @if (!engine.getData().empty) {
          <div class="chips-container">
            <app-active-chip
              [text]="t('zone') + ' (' + engine.getData().zoneAreaPretty + ')'"
              [selected]="engine.editing"
              [color]="engine.getData().empty || startZoneEditEngine.isValid() ? 'default' : 'red'"
              (click)="clickDiscoverBtn(engine)"
              (close)="engine.clear(); stopCurrentEdit()"
            >
            </app-active-chip>
          </div>

          <div class="controls-row margin-top-18">
            <input type="range" min="10" max="100" [formControl]="engine.discoveryPercentControl" class="general-range" />
            <span class="range-label">
            {{ engine.discoveryPercentControl.value }}%
          </span>
          </div>
        }
      }
      <div class="controls-row margin-bottom-12 margin-top-8">
        <button
          class="secondary-bar-btn add-buttons"
          (click)="addObjective(QuestStepObjectiveType.discovery)"
          [ngClass]="{ active: editMode === 'discover' }"
        >
          <svg class="smaller-img-size" viewBox="0 0 24 24" width="18" height="18">
            <use xlink:href="assets/project-icons/add.svg#a"></use>
          </svg>
          {{t('addZone')}}
        </button>
        <app-tooltip [paragraphs]="[t('addZoneTooltipP1')]" [position]="'left'"></app-tooltip>
      </div>
    }

    @if (config.questMode !== QuestMode.noMap) {
      @if (!config?.startZoneHidden) {
        <h4>{{t('startArea')}}</h4>
        <div class="controls-row">
          <button
            class="secondary-bar-btn add-buttons"
            (click)="clickStartZoneBtn()"
            [ngClass]="{ active: editMode === 'startZone' }"
            [disabled]="!startZoneEditEngine.getData().empty"
          >
            <svg class="smaller-img-size" viewBox="0 0 24 24" width="18" height="18">
              <use xlink:href="assets/project-icons/add.svg#a"></use>
            </svg>
            {{t('startArea')}} ({{t('optional')}})
          </button>
          <app-tooltip [paragraphs]="[t('startAreaTooltipP1'), t('startAreaTooltipP2')]" [position]="'left'"></app-tooltip>
        </div>
        @if (!startZoneEditEngine.getData().empty) {
          <div class="controls-row margin-top-18">
            <input type="range" min="4" max="300" [formControl]="startZoneEditEngine.radiusControl" class="general-range" />
            <span class="range-label">
            {{ metersToPretty(startZoneEditEngine.radiusControl.value) }}
          </span>
          </div>
        }
        <div class="chips-container">
          @if (!startZoneEditEngine.getData().empty) {
            <app-active-chip
              [text]="startZoneEditEngine.getData().name + ' (' + startZoneEditEngine.getData().zoneAreaPretty + ')'"
              [selected]="startZoneEditEngine.editing"
              [color]="startZoneEditEngine.getData().empty || startZoneEditEngine.isValid() ? 'default' : 'red'"
              (click)="clickStartZoneBtn()"
              (close)="startZoneEditEngine.clear(); stopCurrentEdit()"
            >
            </app-active-chip>
          }
        </div>
      }

      <h4>{{t('stepHazardZones')}}</h4>

      <div class="controls-row">
        <button class="secondary-bar-btn add-buttons"
                [ngClass]="{ active: editMode === 'hazardZone' }"
                (click)="clickHazardZoneBtn(addNewHazardZone())">
          <svg class="smaller-img-size" viewBox="0 0 24 24" width="18" height="18">
            <use xlink:href="assets/project-icons/add.svg#a"></use>
          </svg>
          {{t('hazardZone')}} ({{t('optional')}})
        </button>

        <app-tooltip
          [paragraphs]="[t('hazardZoneTooltipP1')]"
          [position]="'left'"
        ></app-tooltip>
      </div>

      <div class="chips-container">
        @for (zone of hazardZonesCluster.instances; track zone; let i = $index) {
          <app-active-chip
            [text]="zone.zoneName"
            [selected]="zone.editing"
            [color]="zone.getData().empty || zone.isValid() ? 'default' : 'red'"
            (click)="clickHazardZoneBtn(zone)"
            (close)="removeHazardZone(i)"
          >
          </app-active-chip>
        }
      </div>
    }

    <h4>{{t('stepDuration')}}</h4>

    <div class="controls-row">
      <button class="secondary-bar-btn add-buttons" (click)="clickStepDurationButton()">
        <svg class="smaller-img-size" viewBox="0 0 24 24" width="18" height="18">
          <use xlink:href="assets/project-icons/add.svg#a"></use>
        </svg>

        {{t('stepDuration')}} ({{t('optional')}})
      </button>

      <app-tooltip [paragraphs]="[t('stepDurationTooltipP1'), t('stepDurationTooltipP2')]" [position]="'left'"></app-tooltip>
    </div>

    @if (isTimerVisible || config?.timer) {
      <div [formGroup]="form">
        <mat-form-field appearance="fill" class="form-field margin-top-24 step-duration-input" color="accent">
          <mat-label>{{t('stepDuration')}}</mat-label>
          <input class="step-timer" matInput formControlName="timer" type="text" mask="Hh:m0:s0" placeholder="00:00:00"/>
        </mat-form-field>
      </div>
    }

    <h4>{{t("overlayFromGPX")}}</h4>

    <div class="controls-row">
      @if (!isOverlayAdded()) {
        <button class="secondary-bar-btn add-buttons"
                (click)="importOverlayFromGPX()">
          <svg class="smaller-img-size" viewBox="0 0 24 24" width="18" height="18">
            <use xlink:href="assets/project-icons/add.svg#a"></use>
          </svg>
          {{t('importFromGPX')}}
        </button>
      } @else {
        <button class="secondary-bar-btn add-buttons"
                (click)="removeOverlayGPX()">
          <svg class="smaller-img-size" viewBox="0 0 24 24" width="18" height="18">
            <use xlink:href="assets/project-icons/x.svg#c"></use>
          </svg>
          {{t('removeOverlay')}}
        </button>
      }
      <app-tooltip [paragraphs]="[t('overlayFromGPXDescription')]" [position]="'left'"></app-tooltip>
    </div>

  </div>

  <div id="map-container" class="map">
    @if ((mapControlVisibility$ | async)?.state === 'show') {
      <div class="map-controls">
        @if ((mapControlVisibility$ | async)?.showConfirm) {
          <div class="map-control-slot pointer" (click)="mapControlPanelActions$.next({ button: 'confirm' })">
            <svg class="regular-img-size color-green">
              <use xlink:href="assets/project-icons/check.svg#c"></use>
            </svg>
          </div>
        }
      </div>
    }

    <button class="map-btn" style="top: 156px" (click)="goToMyLocation()">
      <svg class="pointer" viewBox="0 0 24 24" width="20" height="20">
        <use xlink:href="assets/map-icons/location.svg#c"></use>
      </svg>
    </button>

    <button class="map-btn" style="top: 200px" (click)="toggleMagStyle()">
      <svg class="pointer" viewBox="0 0 24 24" width="20" height="20">
        <use xlink:href="assets/map-icons/layers.svg#c"></use>
      </svg>
    </button>
  </div>
</div>

<mat-toolbar class="toolbar bottom element-shadow">
  <span class="filler"></span>
  <button class="primary-bar-btn" (click)="applyClick.emit(apply())" [disabled]="!isValid()">
    <svg class="regular-img-size">
      <use xlink:href="assets/project-icons/check.svg#c"></use>
    </svg>
    {{'apply' | transloco}}
  </button>
</mat-toolbar>
